import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const WIDGET_PDF_EXPORTER = "PdfExporter";

export const PdfExporterWidget: WidgetRegistryEntry = {
  name: WIDGET_PDF_EXPORTER,
  configuration: async () => (await import("./configuration")).PdfExporterWidgetConfiguration,
  component: async () => (await import("./pdf-exporter-widget.component")).PdfExporterWidgetComponent as any
};
